<template>
  <span v-if="text" :class="['badge_comm', badgeSizeClassName, badgeStylelassName]">
    {{ text }}
  </span>
</template>

<script>
export default {
  name:'Badge',
  props:{
    badgeSize: {
      type: String,
      default: 'small'
    },
    badgeStyle: {
      type: String,
      default: 'default'
    },
    badgeFill: {
      type: Boolean,
      default: false
    },
    text: String,
  },
  computed:{
    badgeSizeClassName(){
      return 'badge_'+this.badgeSize;
    },
    badgeStylelassName(){
      return `badge${this.badgeFill ? '_fill' : ''}_${this.badgeStyle}`;
    }
  },
}
</script>
<style lang="scss" scoped>
.badge_comm{display:inline-block;padding:2px 8px;font-weight:700;line-height:20px;border-radius:6px;vertical-align:top}

.badge_xsmall{padding:1px 4px;border-radius:4px;font-size:11px;line-height:14px}
.badge_small{padding:2px 8px;border-radius:6px;font-size:14px;line-height:20px}
.badge_medium{padding:8px 16px;border-radius:10px;font-size:14px;line-height:20px}
.badge_large{padding:13px 16px;border-radius:16px;font-size:16px;line-height:20px}

.badge_default{border:1px solid $DEFAULT_COLOR;background-color:rgba($DEFAULT_COLOR,.2);color:$DEFAULT_COLOR}
.badge_red{border:1px solid $RED_COLOR;background-color:rgba($RED_COLOR,.2);color:$RED_COLOR}
.badge_yellow{border:1px solid $YELLOW_COLOR;background-color:rgba($YELLOW_COLOR,.2);color:$YELLOW_COLOR}
.badge_skyblue{border:1px solid $SKYBLUE_COLOR;background-color:rgba($SKYBLUE_COLOR,.2);color:$SKYBLUE_COLOR}
.badge_lightgreen{border:1px solid $LIGHTGREEN_COLOR;background-color:rgba($LIGHTGREEN_COLOR,.2);color:$LIGHTGREEN_COLOR}
.badge_pink{border:1px solid $PINK_COLOR;background-color:rgba($PINK_COLOR,.2);color:$PINK_COLOR}
.badge_gray{border:1px solid $GRAY_COLOR;background-color:rgba($GRAY_COLOR,.2);color:$GRAY_COLOR}
.badge_orange{border:1px solid $ORANGE_COLOR;background-color:rgba($ORANGE_COLOR,.2);color:$ORANGE_COLOR}
.badge_blue{border:1px solid $BLUE_COLOR;background-color:rgba($BLUE_COLOR,.2);color:$BLUE_COLOR}
.badge_brown{border:1px solid $BROWN_COLOR;background-color:rgba($BROWN_COLOR,.2);color:$BROWN_COLOR}
.badge_green{border:1px solid $GREEN_COLOR;background-color:rgba($GREEN_COLOR,.2);color:$GREEN_COLOR}
.badge_purple{border:1px solid $PURPLE_COLOR;background-color:rgba($PURPLE_COLOR,.2);color:$PURPLE_COLOR}

.badge_fill_default{background-color:$DEFAULT_COLOR;color:#fff}
.badge_fill_red{background-color:$RED_COLOR;color:#fff}
.badge_fill_yellow{background-color:$YELLOW_COLOR;color:#fff}
.badge_fill_skyblue{background-color:$SKYBLUE_COLOR;color:#fff}
.badge_fill_lightgreen{background-color:$LIGHTGREEN_COLOR;color:#fff}
.badge_fill_pink{background-color:$PINK_COLOR;color:#fff}
.badge_fill_gray{background-color:$GRAY_COLOR;color:#fff}
.badge_fill_orange{background-color:$ORANGE_COLOR;color:#fff}
.badge_fill_blue{background-color:$BLUE_COLOR;color:#fff}
.badge_fill_brown{background-color:$BROWN_COLOR;color:#fff}
.badge_fill_green{background-color:$GREEN_COLOR;color:#fff}
.badge_fill_purple{background-color:$PURPLE_COLOR;color:#fff}
</style>